<!--
 * @Description:
 * @Author: 景 彡
 * @Date: 2024-10-16 09:16:19
 * @LastEditors: 景 彡
-->
<template>
</template>

<script lang="ts" setup>
definePage({
  meta: {
    layout: 'admin',
    title: '个人信息',
    isLayout: true,
    local: true,
    icon: 'UserOutlined',
    order: 1,
  },
})
</script>
